exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*base-link-mixin*/\n.dialog-success-content {\n  text-align: center; }\n  .dialog-success-content .body-text {\n    margin: 15px 30px 30px; }\n  .dialog-success-content p:last-of-type {\n    margin-bottom: 30px; }\n  .dialog-success-content .box-success {\n    padding: 30px 0 0 !important;\n    margin: 0; }\n  .dialog-success-content .action-button {\n    padding: 15px;\n    border-top: 1px solid #DFE1E6;\n    padding-top: 15px;\n    text-align: right;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center; }\n  .dialog-success-content .ota-btn-main {\n    margin: 0;\n    width: 160px; }\n    @media screen and (max-width: 768px) {\n      .dialog-success-content .ota-btn-main {\n        background-color: unset;\n        color: #003a90;\n        line-height: unset;\n        height: unset; }\n        .dialog-success-content .ota-btn-main:hover, .dialog-success-content .ota-btn-main.touch {\n          background-color: unset; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modal/dialog-error/dialog-error.component.scss
// module id = 916
// module chunks = 22